import {Button} from 'primereact/button';
import {Card} from 'primereact/card';
import {Image} from 'primereact/image';
import {memo, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {productCategoriesData} from '../data/categories';
import {useAppSelector, useTranslation} from '../hooks';
import {languageState} from '../redux/slices/app';

const productList = Object.values(productCategoriesData);

const HomeProducts = () => {
  const {t} = useTranslation();
  const selectedLanguage = useAppSelector(languageState);
  const navigate = useNavigate();

  const onClick = useCallback(
    (url: string) => navigate('/' + selectedLanguage + t(url)),
    [navigate, selectedLanguage, t],
  );

  return (
    <section
      className="flex flex-wrap justify-content-center align-items-center py-8"
      id="productcategories">
      {productList.map((category, index) => (
        <div key={index} className="col-12 md:col-6 lg:col-3">
          <Card
            title={t(category.title)}
            className="text-center"
            style={{
              borderRadius: '12px',
              overflow: 'hidden',
            }}>
            <div className="flex flex-column justify-content-center align-items-center gap-5">
              <picture className="w-full h-full">
                <source srcSet={category.avifImage} type="image/avif" />
                <source srcSet={category.webpImage} type="image/webp" />
                <Image
                  src={category.imageUrl}
                  alt={category.title}
                  width="200"
                  height="150"
                  imageStyle={{borderRadius: '50%', objectFit: 'cover'}}
                  preview
                />
              </picture>

              <Button
                className="flex flex-row justify-content-center align-items-center no-underline gap-3"
                label={t('homeProductCategoriesTitle')}
                aria-label={t('homeProductCategoriesTitle')}
                iconPos="right"
                icon="pi pi-arrow-right"
                severity="contrast"
                onClick={() => onClick(category.url)}
              />

              {/* <Link
                to={'/' + selectedLanguage + t(category.url)}
                className="flex flex-row justify-content-center align-items-center no-underline gap-3">
                <p className="mt-3 p-button-text text-lg">
                  {t('homeProductCategoriesTitle')}
                </p>
                <i className="pi pi-arrow-right"></i>
              </Link> */}
            </div>
          </Card>
        </div>
      ))}
    </section>
  );
};

export default memo(HomeProducts);
